module.exports = __webpack_public_path__ + "img/HQ.e7f164c5.png";